import React, { Fragment } from 'react'
import { selectors as appSelectors } from '../features/app'
import { useSelector } from 'react-redux'
import { EAppVersion } from '../features/app/types';


const Footer: React.FC = () => {
  const version = useSelector(appSelectors.getAppVersion);
  const step = useSelector(appSelectors.getAppStep);
  const subStep = useSelector(appSelectors.getAppSubStep);
  const showEstimateDisclaimer = step === 3 && version == EAppVersion.a;
  const showPrivacyDisclaimer = step === 2;
  const showTrademarkDisclaimer = step === 0 && subStep === 1;
  const showDisclaimers = showEstimateDisclaimer || showPrivacyDisclaimer || showTrademarkDisclaimer;

  return (
    <Fragment>
      {showDisclaimers ? 
      <footer className="i-footer">
        <div className="i-disclaimers">
          <div className="i-con">
          {showEstimateDisclaimer ? 
            <p>
              * This is an estimate only. One of our friendly Dealer Staff will contact you to discuss your valuation. Toyota Motor Corporation Australia Ltd (TMCA) and/or Toyota dealers are not bound by any valuation provided via this valuation tool. The valuation tool should not be relied upon to provide a precise value or price for your used vehicle as many factors that can affect this. This valuation tool provides an indicative value only and any price will be determined at a dealer’s discretion and could be higher or lower than provided in the valuation tool.
            </p> 
          : ''}
          {showPrivacyDisclaimer ? 
            <p>Our Guests' privacy is important to Toyota. Toyota Motor Corporation Australia Limited &amp; Toyota Finance Australia Limited collect your personal information &amp; handle it in accordance with our Privacy Policy available at <a href="http://toyota.com.au/privacy" target="_blank">toyota.com.au/privacy</a>.</p>
          : ''}
          {showTrademarkDisclaimer ? 
            <p>Product &amp; company names are trademarks of their respective owners</p>
          : ''}
          </div>
        </div>
      </footer>
        : ''}
    </Fragment>
  )
}

export default Footer
